const AVAILABLE_LOCALES = ['en', 'de', 'fr-CA', 'el', 'es-US', 'en-GB', 'fr', 'es', 'it', 'fi', 'sk', 'pl', 'nl', 'sv', 'da', 'cs', 'nb-NO', 'pt-PT', 'ar']; // add new locales as they become available

module.exports.availableLocales = AVAILABLE_LOCALES;
